const _ = require('./enum');
module.exports = {
  [_.NO_3DS]: { id: _.NO_3DS, label: 'No 3DS' },
  [_.ASK_3DS]: { id: _.ASK_3DS, label: 'Ask 3DS' },
  [_.FORCE_3DS]: { id: _.FORCE_3DS, label: 'Force 3DS' },
};
